<template>
  <el-col
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <el-col
      :xl="{ span: 8 }"
      :lg="{ span: 8 }"
      :md="{ span: 8 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <!--左边封面部分-->
      <coverComponent></coverComponent>
    </el-col>
    <el-col
      :xl="{ span: 16 }"
      :lg="{ span: 16 }"
      :md="{ span: 16 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <!--中间内容部分-->
      <mainContentComponent></mainContentComponent>
    </el-col>
  </el-col>
</template>
<script>
import loginComponent from '@/components/loginComponent'
import coverComponent from '@/components/coverComponent'
import mainContentComponent from '@/components/mainContentComponent'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: 'home',
  components: {
    vueSeamlessScroll,
    loginComponent,
    coverComponent,
    mainContentComponent
  },
  data () {
    return {

    }
  },
  created () {
    this.reload()
  },
  methods: {
    reload () {
      if (!window.name) {
        window.name = 'test'
        location.reload()
      }
    }
  }
}
</script>

<style scoped>
.el-container {
  /* background-color: black; */
}
.el-row {
  background-color: white;
  margin: auto;
}
.el-main {
  background-color: yellow;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue